import usePermittedQuery from '_api/queries/usePermittedQuery';
import { Report } from '_api/types';
import { ACCOUNT_TYPE } from '_constants';

export const GET_GOAL_REPORT_ID = 'get-goal-report';

export const useGetGoalReport = (goalId: number, startDate: string, endDate: string) => {
  return usePermittedQuery<Report>(
    [
      ACCOUNT_TYPE.ADMIN,
      ACCOUNT_TYPE.ORG_ADMIN,
      ACCOUNT_TYPE.HOS_ADMIN,
      ACCOUNT_TYPE.THERAPIST,
    ],
    () =>
      `/submission/goal/progress?startDate=${startDate}&endDate=${endDate}&goalId=${goalId}`,
    {},
    [GET_GOAL_REPORT_ID],
    {
      enabled: typeof goalId === 'number' && goalId >= 0,
      refetchOnWindowFocus: false,
    },
  );
};
